<template>
  <div class="container">
    <div
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <el-button @click="add" type="primary" size="mini"
        >+ {{ $t("public.add") }}
      </el-button>
      <div style="display: flex">
        <el-button type="primary" size="mini" @click="exportExcel"
          >导出</el-button
        >
        <el-input
          size="mini"
          :placeholder="
            searchType == 1 ? $t('public.ver1') : $t('public.ver14')
          "
          v-model="searchKey"
          @keyup.enter.native="toSearch"
          style="margin-left: 20px"
        >
          <el-select style="width: 100px" v-model="searchType" slot="prepend">
            <el-option
              v-for="item in searchOpts"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="toSearch"
          ></el-button
        ></el-input>
      </div>
    </div>

    <div class="table">
      <!-- :cell-style="{ padding: '5px' }" -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        ref="table"
        height="100%"
        :empty-text="emptyText"
      >
        <el-table-column
          v-for="(item, index) in column"
          show-overflow-tooltip
          :key="index"
          align="center"
          :prop="column[index].key"
          :label="$t(`public.${column[index].key}`)"
          :width="column.width"
        >
          <template slot-scope="scoped">
            <span v-if="column[index].key == 'ctime'">
              {{ scoped.row[item.key] ? diffTime(scoped.row[item.key]) : "" }}
            </span>
            <span v-else>
              {{ scoped.row[item.key] }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('public.auth')" width="400">
          <!-- :width="column.width" -->

          <template slot-scope="scoped">
            <el-button
              size="small"
              type="primary"
              @click="viewList(scoped.row)"
              >{{
                $t("public.view") +
                `(${scoped.row.stations ? scoped.row.stations.length : 0})`
              }}</el-button
            >
            <el-button size="small" type="info" @click="edit(scoped.row)">{{
              $t("public.edit")
            }}</el-button>
            <el-button size="small" type="danger" @click="del(scoped.row)">{{
              $t("public.del")
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <viewList
      :show.sync="viewShow"
      :rowInfo.sync="rowInfo"
      type="view"
    ></viewList>
    <editVue
      :show.sync="editShow"
      :rowInfo.sync="rowInfo"
      type="edit"
      @refush="refush"
    ></editVue>
    <addVue
      :show.sync="addShow"
      :rowInfo.sync="rowInfo"
      type="add"
      @refush="refush"
    ></addVue>
  </div>
</template>
  
  <script>
import editVue from "./components/edit.vue";
import viewList from "./components/viewList.vue";
import addVue from "./components/add.vue";
import { getNtripUsers, delUser } from "@/api/index";
export default {
  name: "OverseasStationManageUserManage",
  components: {
    viewList,
    editVue,
    addVue,
  },
  data() {
    return {
      emptyText: this.$t("public.loading"),
      viewShow: false, // 查看列表弹窗
      editShow: false, // 编辑弹窗
      addShow: false, // 编辑弹窗
      rowInfo: {},
      total: 0,
      pageSize: 10,
      page: 1,
      column: [
        { label: "用户名", key: "name" },
        { label: "密码", key: "password" },
        { label: "创建人", key: "cBy" },
        { label: "连接数量限制", key: "cnum" },
        { label: "创建时间", key: "ctime" },
      ],
      tableData: [],
      allData: [],
      searchKey: "",
      searchData: [], // 搜索数据
      searchOpts: [
        {
          value: "1",
          label: this.$t("public.name"),
        },
        {
          value: "2",
          label: this.$t("public.auth"),
        },
      ], // 搜索项
      searchType: "1", // 搜索类型
    };
  },

  activated() {
    this.getList();
  },
  deactivated() {
    this.page = 1;
  },

  methods: {
    // 导出
    exportExcel() {
      let columnNames = [
        this.$t("public.name"),
        this.$t("public.password"),
        this.$t("public.cBy"),
        this.$t("public.cnum"),
        this.$t("public.ctime"),
        this.$t("public.auth"),
      ];
      let columnDatas = ["name", "password", "cBy", "cnum", "ctime", "sts"];
      this.$tool.exportExcel(
        "NTRIP_Account_" + this.$moment().format("YYYY-MM-DD"),
        columnDatas,
        columnNames,
        this.searchData.length ? this.searchData : this.allData
      );
    },
    diffTime(time) {
      let t = new Date(time);
      let temp = t.getTime() + this.getLocalTime();
      const dateObj = new Date(temp);
      // 格式化为年-月-日 时:分:秒字符串
      const formattedDateTime = `${dateObj.getFullYear()}-${String(
        dateObj.getMonth() + 1
      ).padStart(2, "0")}-${String(dateObj.getDate()).padStart(
        2,
        "0"
      )} ${String(dateObj.getHours()).padStart(2, "0")}:${String(
        dateObj.getMinutes()
      ).padStart(2, "0")}:${String(dateObj.getSeconds()).padStart(2, "0")}`;
      return formattedDateTime;
    },
    // 返回当地时间和北京时间的时间戳差值
    getLocalTime() {
      let d = new Date();
      //算得时区
      var time_zone = -d.getTimezoneOffset() / 60;
      if (time_zone < 0) {
        time_zone = -(Math.abs(time_zone) + 8);
      } else {
        time_zone -= 8;
      }
      return time_zone * 60 * 60 * 1000;
    },
    toSearch() {
      if (this.searchKey) {
        this.emptyText = this.$t("public.loading");
        if (this.searchType == 1) {
          this.searchData = this.allData.filter((item) =>
            item.name
              .toLocaleLowerCase()
              .includes(this.searchKey.toLocaleLowerCase())
          );
        } else if (this.searchType == 2) {
          this.searchData = this.allData.filter((item) => {
            return item.st.includes(this.searchKey.toLocaleLowerCase());
          });
        }
        if(this.searchData.length == 0){
          this.emptyText = this.$t("public.noData");
        }
        this.total = this.searchData.length;
        this.paging();
      } else {
        this.refush();
      }
    },
    refush() {
      this.page = 1;
      this.getList();
    },
    handleSizeChange() {
      this.paging();
    },
    handleCurrentChange() {
      this.paging();
    },
    getList() {
      let param = {
        searchField: "",
      };
      getNtripUsers(param).then((res) => {
        if (!res.data || !res.data.length || res.data.length == 0) {
          this.emptyText = this.$t("public.noData");
        }
        this.allData = res.data.map((item, index) => {
          return {
            id: index,
            name: item.UserName,
            password: item.PassWord,
            cnum: item.Limit,
            ctime: item.CreatedAt,
            cBy: item.CreatedBy || "",
            stations: item.AvailableStations.endsWith("|")
              ? item.AvailableStations.slice(0, -1).split("|")
              : item.AvailableStations.split("|"),
            st: item.AvailableStations.endsWith("|")
              ? item.AvailableStations.toLocaleLowerCase()
                  .slice(0, -1)
                  .split("|")
              : item.AvailableStations.toLocaleLowerCase().split("|"),
            sts: item.AvailableStations,
          };
        });
        this.total = this.allData.length;
        this.paging();
      });
    },
    paging() {
      // 起始位置 = (当前页 - 1) x 每页的大小
      const start = (this.page - 1) * this.pageSize;
      // 结束位置 = 当前页 x 每页的大小
      const end = this.page * this.pageSize;
      // this.tableData = this.allData.slice(start, end);
      this.tableData = this.searchKey
        ? this.searchData.slice(start, end)
        : this.allData.slice(start, end);
      // console.log(this.tableData, start, end);
    },
    add() {
      this.addShow = true;
    },
    viewList(row) {
      this.viewShow = true;
      this.rowInfo = row;
    },
    edit(row) {
      this.rowInfo = row;
      this.editShow = true;
    },
    del(row) {
      this.$confirm(this.$t("public.sureDel"), this.$t("public.tip"), {
        confirmButtonText: this.$t("public.submit"),
        cancelButtonText: this.$t("public.cancel"),
        type: "warning",
      })
        .then(() => {
          let param = {
            username: row.name,
          };
          delUser(param).then((res) => {
            if (res.code == 200) {
              this.$message.success(this.$t("public.success3"));
              this.page = 1;
              this.getList();
            }
          });
          // this.$message.success("删除成功");
        })
        .catch(() => {
          //   this.$message({
          //     type: 'info',
          //     message: '已取消删除'
          //   });
          return;
        });
    },
  },
};
</script>
  <style lang="scss" scoped>
.table {
  height: calc(100% - 30px - 32px - 28px);
  margin-top: 10px;
}
.pagination {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
::v-deep {
  .table th.el-table__cell {
    background-color: #3e916a;
    color: #fff;
    border: none;
  }
}
</style>